const state = {
	token: localStorage.getItem('2716token') || "", //判断是否登录
	userInfo: localStorage.getItem('2716UserInfo') ? JSON.parse(localStorage.getItem('2716UserInfo')) : "",
}
const mutations = {
	set_token(state, val) {
		state.token = val
		localStorage.setItem('2716token', val)
	},
	set_user(state, val) {
		state.userInfo = val
		localStorage.setItem('2716UserInfo', JSON.stringify(val))
	},
	loginOut(state) {
		state.token = ""
		state.userInfo = ""
		localStorage.removeItem('token')
		localStorage.removeItem('2716UserInfo')
	}
}
const actions = {}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}